export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_iw.dba6f047c549ee52.json"